import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';

import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {CompanyStatus} from "../type/company-status";

@Component({
    selector: 'app-company-status-add',
    templateUrl: './company-status-add.component.html',
})
export class CompanyStatusAddComponent implements OnInit {
    node = 'company-status';
    companyStatus: CompanyStatus = CompanyStatus;

    constructor(
        private dataService: DataService,
        private apiService: ApiService,
        private location: Location
    ) {}

    ngOnInit() {
        this.dataService.refresh();
    }

    onFormSubmit(formData) {
        var data = {
            company_status : formData.value.company_status,
            company_status_class : formData.value.company_status_class,
        };
        this.apiService.postNew(this.node, data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: Company Status added successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/company-status/company-status-add.component.ts